<template>
	<div>
		<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif">
			<div class="dialog" style="background-color: #eeeeee">
				<div class="dialog-header">
					<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("options") }}</span>
					<div style="margin-left: auto; margin-right: 0px">
						<md-button @click="close" class="md-icon-button" style="margin-right: -5px">
							<md-icon style="color: white">close</md-icon>
						</md-button>
					</div>
				</div>
				<div class="dialog-body" style="width: 100%">
					<div class="table">
						<h3>{{ $t("available-options") }}</h3>
						<md-table v-model="array" md-fixed-header max-height="100">
							<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
								<md-table-cell md-label="#">{{ array.indexOf(item) + 1 }}</md-table-cell>
								<md-table-cell :md-label="$t('name')">{{ item.value }}</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
					<md-divider style="margin: 20px 5px"></md-divider>
					<div class="form" style="top: 50%">
						<h3>{{ $t("add-option") }}</h3>
						<el-form ref="option" label-width="100px" class="demo-ruleForm">
							<el-form-item :label="$t('new-option')">
								<strong slot="label">{{ $t("new-option") }}</strong>
								<el-input v-model="option" :placeholder="$t('option')"></el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="dialog-footer">
					<div style="margin-left: auto; margin-right: 0px">
						<md-button class="cancel" @click="close">{{ $t("cancel") }}</md-button>
						<md-button class="add" @click="add">
							<i class="el-icon-loading" v-if="loading" />
							<span>{{ $t("add") }}</span>
						</md-button>
					</div>
				</div>
			</div>
		</md-dialog>
	</div>
</template>
<script>
import axios from "axios"
export default {
	name: "subscriptions-options",
	props: ["show"],
	data() {
		return {
			array: [],
			option: undefined,
			loading: false
		}
	},
	methods: {
		close: function () {
			this.option = ""
			this.$emit("close")
		},
		add: function () {
			this.loading = true
			if (!this.option || this.option == "") {
				alert("empty option")
				return
			}

			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/setting/add",
					{
						key: "subscriptions",
						value: this.option
					},
					{
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					}
				)
				.then(res => {
					// this.close()
					this.array.push(res.data.option)
				})
				.catch(err => console.error(err))
			this.loading = false
		}
	},
	created() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/setting/subscriptions", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				this.array = res.data.result
			})
			.catch(err => console.error(err))
	}
}
</script>

<style scoped>
table {
	max-height: 10;
}
</style>
